module.exports = __webpack_public_path__ + "static/media/backgroundImage-pankaj.189edaf5.jpg";